import React from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { DealGroup, SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';

export interface CollapsibleTableRowProps {
  group: DealGroup;
  colSpan: number;
  rowIndexStart: number;
  renderChildRows: (valuations: SimplifiedAttioValuation[], rowIndexStart: number) => React.ReactNode;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const CollapsibleTableRow = ({
  group,
  colSpan,
  rowIndexStart,
  renderChildRows,
  isCollapsed = false,
  onToggleCollapse,
}: CollapsibleTableRowProps) => {
  const expanded = !isCollapsed;
  const displayName = group.deal_name ?? 'No deal';
  const count = group.valuations.length;

  return (
    <>
      <TableRow
        sx={{
          backgroundColor: '',
          '&:hover': { backgroundColor: 'action.selected' },
        }}
      >
        <TableCell colSpan={colSpan} sx={{ px: 0.75, py: 0.75, pl: 0, verticalAlign: 'middle' }}>
          <IconButton
            size="small"
            onClick={onToggleCollapse}
            aria-expanded={expanded}
            sx={{ mr: 0.5, p: 0.25 }}
          >
            {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
          <span style={{ fontWeight: 600 }}>
            {displayName} ({count} valuation{count > 1 ? 's' : ''})
          </span>
        </TableCell>
      </TableRow>
      {expanded && renderChildRows(group.valuations, rowIndexStart)}
    </>
  );
};

export default CollapsibleTableRow;